import { DefaultCachingNumberFormatter as NumberFormatter } from '@square/dashboard-translations/utils/field-kit/default-caching-number-formatter';
export default class SatoshiCurrencyFormatter extends NumberFormatter {
  constructor() {
    super();
    // NOTE(dhuxley): 'Sat' or 'sats' is the common suffix of satoshis, but it varies
    // based on singular or plural, which is not known when building the formatter.
    // So, the caller of this formatter builder will need to set `Sat` or `sats` if desired.
    this.setNumberStyle(NumberFormatter.Style.CURRENCY).setMaximumFractionDigits(1).setMinimumFractionDigits(0).setPositivePrefix('').setPositiveSuffix('').setNegativePrefix('-').setNegativeSuffix('');
  }
}
export const BITCOIN_TO_SATOSHI = 100_000_000;